import { AuditLogsAccessResponse } from 'api';
import { FlatOption } from 'pages/AuditLogs/types';

const getOptionsFromScope = (scope: AuditLogsAccessResponse): FlatOption[] => {
  const { standalone_companies: standaloneCompanies, firms } = scope;
  const options = standaloneCompanies.map(company => ({
    value: `company-${company.id}`,
    label: company.name,
    kind: 'standalone',
  })) as FlatOption[];

  firms.forEach(firm => {
    const parentOption: FlatOption = {
      value: `firm-${firm.id}`,
      label: firm.name,
      kind: 'firm',
    };
    options.push(parentOption);

    firm.funds.forEach(fund => {
      options.push({
        value: `fund-${fund.id}`,
        label: fund.name,
        kind: 'fund',
        parentValue: parentOption.value,
        parentLabel: parentOption.label,
        childGroup: 'funds',
      });
    });

    firm.companies.forEach(company => {
      options.push({
        value: `company-${company.id}`,
        label: company.name,
        kind: 'company',
        parentValue: parentOption.value,
        parentLabel: parentOption.label,
        childGroup: 'companies',
      });
    });
  });

  return options;
};

export default getOptionsFromScope;
